import React from 'react';
import './WordDetail.css'


export default class WordDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            srcString: 'https://www.gankao.com/p-lubo/tag/tbsz'
        }
    };

    render() {
        let { srcString } = this.state

        return (<div>
            <div>
                <div className="panel_iframe" style={{ width: '100%', height: '100%', border: '0' }}>
                    <iframe src={srcString} sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals" />
                </div>
            </div>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/word_detail/TongBu.js